import { AUTH_ILLUSTRATIONS } from "../../../components/AuthPasswordLayout/illustrations";

export const SIGNUP_URL = "https://jusfy.com.br/home/#planos";

// Auth 2.0 Centralizado
export const NEW_AUTH_SERVICE_APP_NAME = "jusfy-app";

export const AuthStatus = {
  REQUIRED_2FA: "require_2fa",
  SUCCESS: "success",
} as const;

export const LoginIdentifyStatus = {
  PASSWORD_REQUIRED: "password_required",
  PASSWORD_NOT_CREATED: "password_not_created",
  FIRST_ACCESS_PENDING: "first_access_pending",
} as const;

export const LoginStep = {
  EMAIL: "email",
  PASSWORD: "password",
  PASSWORD_NOT_CREATED: "password_not_created",
} as const;

export type LoginStepValue = typeof LoginStep[keyof typeof LoginStep];

export const LOGIN_STEP_ILLUSTRATION: Record<LoginStepValue, string> = {
  [LoginStep.EMAIL]: AUTH_ILLUSTRATIONS.HOME_LOGIN,
  [LoginStep.PASSWORD]: AUTH_ILLUSTRATIONS.HOME_LOGIN,
  [LoginStep.PASSWORD_NOT_CREATED]: AUTH_ILLUSTRATIONS.CREATE_PASSWORD,
};
